import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { isEmpty } from "lodash";
import "../../settings.styles.css";
import StatusViewEditComponent from "../components/statusViewEditComponent";
import SettingsPanel from "../../components/SettingsPanel";
import { toast } from "react-toastify";
import DeleteModal from "../../../../Components/Common/DeleteModal";

import {
  createCustomerURLLinkStatus,
  createCustomerURLLinkStatusSuccess,
  createCustomerURLLinkType,
  createCustomerURLLinkTypeSuccess,
  deleteCustomerURLLinkStatus,
  deleteCustomerURLLinkStatusSuccess,
  deleteCustomerURLLinkType,
  deleteCustomerURLLinkTypeSuccess,
  getCustomerURLLinkStatusListData,
  getCustomerURLLinkTypeListData,
  updateCustomerURLLinkStatus,
  updateCustomerURLLinkStatusSuccess,
  updateCustomerURLLinkType,
  updateCustomerURLLinkTypeSuccess,
} from "../../../../store/customers/action";
import CustomerDetailsUpdate from "./CustomerDetailsUpdate";
import TabStorageLocations from "./tabStorageLocations";
import VatRegistrationHistory from "./VatRegistrationHistory";
export default function CompanySettings() {
  const dispatch = useDispatch();

  const { customerUrlLinkStatusListAPI, customerUrlLinkTypeListAPI } =
    useSelector((state) => ({
      customerUrlLinkStatusListAPI:
        state.Customers.customerUrlLinkStatusList?.customerurllinkstatus_list,
      customerUrlLinkTypeListAPI:
        state.Customers.customerUrlLinkTypeList?.customerurllinktype_list,
    }));

  const [statusList, setStatusList] = useState([]);
  const [activeTab, setActiveTab] = useState("0");
  const [deleteStatus, setDeleteStatus] = useState("");
  const [createStatus, setCreateStatus] = useState({
    Name: "New Status",
    CssColourText: "#000000",
    CssColourBackground: "#F4F0F0",
  });

  const handleCreateNewStatus = () => {
    if (activeTab === "1") {
      // Task Status create
      dispatch(createCustomerURLLinkStatus([createStatus]));
    }
    if (activeTab === "2") {
      // Task Type create
      dispatch(createCustomerURLLinkType([createStatus]));
    }
  };

  useEffect(() => {
    let data = [];
    if (activeTab === "1") {
      data = customerUrlLinkStatusListAPI?.sort((a, b) => b.Id - a.Id);
    }
    if (activeTab === "2") {
      data = customerUrlLinkTypeListAPI?.sort((a, b) => b.Id - a.Id);
    }

    setStatusList(data);
  }, [customerUrlLinkStatusListAPI, customerUrlLinkTypeListAPI, activeTab]);

  useEffect(() => {
    dispatch(getCustomerURLLinkStatusListData());
    dispatch(getCustomerURLLinkTypeListData());
  }, []);

  const Tabs = [
    {
      id: "0",
      name: "Company Details",
      slug: "company-details",
    },
    {
      id: "3",
      name: "Storage Locations",
      slug: "storage-locations",
    },
    {
      id: "4",
      name: "VAT Registration",
      slug: "vat-registration",
    },
    // {
    //   id: "1",
    //   name: "URL Link Status",
    // },
    // {
    //   id: "2",
    //   name: "URL Link Type",
    // },
  ];
  const [deleteModal, setDeleteModal] = useState(false);
  const handleDeleteStatus = () => {
    if (activeTab === "1") {
      //  Task Status delete

      dispatch(deleteCustomerURLLinkStatus([deleteStatus]));
    }
    if (activeTab === "2") {
      // Task Type delete
      dispatch(deleteCustomerURLLinkType([deleteStatus]));
    }
  };
  const [updateItemStatus, setUpdateItemStatus] = useState({});

  // Update Module
  useEffect(() => {
    if (isEmpty(updateItemStatus)) return;
    let updateNewStatus = {
      Id: updateItemStatus?.Id,
      Name: updateItemStatus?.Name,
      CssColourBackground: updateItemStatus?.CssColourBackground,
      CssColourText: updateItemStatus?.CssColourText,
    };
    const delayUpdate = setTimeout(() => {
      if (activeTab === "1") {
        // Task Status update

        dispatch(updateCustomerURLLinkStatus([updateNewStatus]));
      }
      if (activeTab === "2") {
        // Task Type update
        dispatch(updateCustomerURLLinkType([updateNewStatus]));
      }
    }, 500);
    return () => clearTimeout(delayUpdate);
  }, [updateItemStatus]);

  const {
    createCustomerUrlLinkStatusResponseAPI,
    updateCustomerUrlLinkStatusResponseAPI,
    deleteCustomerUrlLinkStatusResponseAPI,
    createCustomerUrlLinkTypeResponseAPI,
    updateCustomerUrlLinkTypeResponseAPI,
    deleteCustomerUrlLinkTypeResponseAPI,
  } = useSelector((state) => ({
    createCustomerUrlLinkStatusResponseAPI:
      state.Customers.createCustomerUrlLinkStatusResponse,
    updateCustomerUrlLinkStatusResponseAPI:
      state.Customers.updateCustomerUrlLinkStatusResponse,
    deleteCustomerUrlLinkStatusResponseAPI:
      state.Customers.deleteCustomerUrlLinkStatusResponse,
    createCustomerUrlLinkTypeResponseAPI:
      state.Customers.createCustomerUrlLinkTypeResponse,
    updateCustomerUrlLinkTypeResponseAPI:
      state.Customers.updateCustomerUrlLinkTypeResponse,
    deleteCustomerUrlLinkTypeResponseAPI:
      state.Customers.deleteCustomerUrlLinkTypeResponse,
  }));

  //Create Customer Url Link Status response
  useEffect(() => {
    if (isEmpty(createCustomerUrlLinkStatusResponseAPI)) return;
    if (createCustomerUrlLinkStatusResponseAPI?.status === 200) {
      toast.success(createCustomerUrlLinkStatusResponseAPI?.message);
      dispatch(getCustomerURLLinkStatusListData());
    } else {
      toast.error(createCustomerUrlLinkStatusResponseAPI?.message);
    }
    dispatch(createCustomerURLLinkStatusSuccess([]));
  }, [createCustomerUrlLinkStatusResponseAPI]);

  //Update Customer Url Link Status response
  useEffect(() => {
    if (isEmpty(updateCustomerUrlLinkStatusResponseAPI)) return;
    if (updateCustomerUrlLinkStatusResponseAPI?.status === 200) {
      toast.success(updateCustomerUrlLinkStatusResponseAPI?.message);
      dispatch(getCustomerURLLinkStatusListData());
    } else {
      toast.error(updateCustomerUrlLinkStatusResponseAPI?.message);
    }
    dispatch(updateCustomerURLLinkStatusSuccess([]));
  }, [updateCustomerUrlLinkStatusResponseAPI]);

  //Delete Customer Url Link Status response
  useEffect(() => {
    if (isEmpty(deleteCustomerUrlLinkStatusResponseAPI)) return;
    if (deleteCustomerUrlLinkStatusResponseAPI?.status === 200) {
      toast.success(deleteCustomerUrlLinkStatusResponseAPI?.message);
      dispatch(getCustomerURLLinkStatusListData());
      setDeleteModal(false);
    } else {
      toast.error(deleteCustomerUrlLinkStatusResponseAPI?.message);
    }
    dispatch(deleteCustomerURLLinkStatusSuccess([]));
  }, [deleteCustomerUrlLinkStatusResponseAPI]);

  //Create Customer Url Link Type response
  useEffect(() => {
    if (isEmpty(createCustomerUrlLinkTypeResponseAPI)) return;
    if (createCustomerUrlLinkTypeResponseAPI?.status === 200) {
      toast.success(createCustomerUrlLinkTypeResponseAPI?.message);
      dispatch(getCustomerURLLinkTypeListData());
    } else {
      toast.error(createCustomerUrlLinkTypeResponseAPI?.message);
    }
    dispatch(createCustomerURLLinkTypeSuccess([]));
  }, [createCustomerUrlLinkTypeResponseAPI]);

  //Update Customer Url Link Type response
  useEffect(() => {
    if (isEmpty(updateCustomerUrlLinkTypeResponseAPI)) return;
    if (updateCustomerUrlLinkTypeResponseAPI?.status === 200) {
      toast.success(updateCustomerUrlLinkTypeResponseAPI?.message);
      dispatch(getCustomerURLLinkTypeListData());
    } else {
      toast.error(updateCustomerUrlLinkTypeResponseAPI?.message);
    }
    dispatch(updateCustomerURLLinkTypeSuccess([]));
  }, [updateCustomerUrlLinkTypeResponseAPI]);

  //Delete Customer Url Link Type response
  useEffect(() => {
    if (isEmpty(deleteCustomerUrlLinkTypeResponseAPI)) return;
    if (deleteCustomerUrlLinkTypeResponseAPI?.status === 200) {
      toast.success(deleteCustomerUrlLinkTypeResponseAPI?.message);
      dispatch(getCustomerURLLinkTypeListData());
      setDeleteModal(false);
    } else {
      toast.error(deleteCustomerUrlLinkTypeResponseAPI?.message);
    }
    dispatch(deleteCustomerURLLinkTypeSuccess([]));
  }, [deleteCustomerUrlLinkTypeResponseAPI]);

  return (
    <>
      <DeleteModal
        show={deleteModal}
        onDeleteClick={handleDeleteStatus}
        onCloseClick={() => {
          setDeleteModal(false);
        }}
      />
      <SettingsPanel
        title="Company Settings"
        description="Company details and storage locations."
        tabs={Tabs.map((item) => ({
          value: item.id,
          label: item.name,
          slug: item.slug,
        }))}
        value={activeTab}
        onChange={setActiveTab}
      >
        {activeTab === "0" && (
          <div>
            <CustomerDetailsUpdate />
          </div>
        )}
        {activeTab === "3" && <TabStorageLocations />}
        {activeTab === "4" && <VatRegistrationHistory />}
        {activeTab !== "0" && activeTab !== "3" && activeTab !== "4" && (
          <StatusViewEditComponent
            statusList={statusList}
            setStatusList={setStatusList}
            createStatus={createStatus}
            setCreateStatus={setCreateStatus}
            handleCreateNewStatus={handleCreateNewStatus}
            setDeleteStatus={setDeleteStatus}
            setDeleteModal={setDeleteModal}
            setUpdateItemStatus={setUpdateItemStatus}
          />
        )}
      </SettingsPanel>
    </>
  );
}
